/*
Copyright 2022 Google Inc. All rights reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
// NOTICE --- MODIFIED FOR WISPR-lab/data-export-gui

import Vue from 'vue'
import App from './App.vue'

import router from './router.js'
import store from './store.js'

import '@/mixins/snackBar'

import vuetify from '@/plugins/vuetify' // path to vuetify export
import SafeExitButton from '@/components/SafeExitButton.vue'

import { getPyodideWorker } from '@/pyodide/pyodide-client'

require('./assets/main.scss')
require('./assets/markdown.scss')
require('./assets/roboto.css')
require('./utils/RegisterAppFilters')

// Register global components
Vue.component('SafeExitButton', SafeExitButton)

// Third party
Vue.use(require('vue-moment'))

// Disable warning during development
Vue.config.productionTip = false

// Boot Pyodide worker immediately so packages load in the background on any route
getPyodideWorker()

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload()
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')

